module.exports = __webpack_public_path__ + "static/media/tutorial-card-3.b9c7d3ff.png";